import Event from './Event';
import Timeline from '@mui/lab/Timeline';


export default function EventList({ list }) {  
  return <Timeline>
        {list.map((n,i) => <Event key={i} ev={n} first={i===0} last={i===list.length-1} />)}
      </Timeline>
}